function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import FoldoutItem from './FoldoutItem';
const FoldoutOptions = _ref => {
  let {
    customElements,
    fallbackOption,
    nested,
    noResultsTitle,
    optionSectionBodyKey,
    optionSectionKey,
    options,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !options.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    className: classNames('no-results', {
      fallback: fallbackOption
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: "info"
  }, noResultsTitle)), fallbackOption && /*#__PURE__*/React.createElement(FoldoutItem, _extends({}, rest, {
    item: fallbackOption
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, options.map((item, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: classNames('section', {
        nested
      })
    }, nested ? /*#__PURE__*/React.createElement(React.Fragment, null, item[optionSectionKey] && /*#__PURE__*/React.createElement("h5", {
      className: "section-title"
    }, item[optionSectionKey]), item[optionSectionBodyKey].map((row, rowIndex) => {
      return /*#__PURE__*/React.createElement(FoldoutItem, _extends({}, rest, {
        key: rowIndex,
        item: row
      }));
    })) : /*#__PURE__*/React.createElement(FoldoutItem, _extends({}, rest, {
      item: item
    })));
  }), customElements));
};
FoldoutOptions.defaultProps = {
  noResultsTitle: 'No results found!'
};
FoldoutOptions.propTypes = {
  customElements: PropTypes.node,
  nested: PropTypes.bool,
  optionSectionBodyKey: PropTypes.string,
  optionSectionKey: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object)
};
export default /*#__PURE__*/memo(FoldoutOptions);